export enum ProviderOperationRateActionsTypes {
  READ = "@@PROVIDER_OPERATION_RATE read",
  READ_STATUS = "@@PROVIDER_OPERATION_RATE read status",
  DELETE_ONE = "@@PROVIDER_OPERATION_RATE delete one",
  DELETE_ONE_STATUS = "@@PROVIDER_OPERATION_RATE delete one"
}
